"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var Link_1 = __importDefault(require("../../navigation/Link"));
exports.Wrapper = (0, styled_components_1.default)(Link_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  ", "\n\n  ", " {\n    transition: transform 0.1s ease, box-shadow 0.1s ease;\n    will-change: transform;\n\n    &:hover {\n      transform: translateY(-7px);\n      ", "\n    }\n  }\n"], ["\n  display: block;\n  ", "\n\n  ", " {\n    transition: transform 0.1s ease, box-shadow 0.1s ease;\n    will-change: transform;\n\n    &:hover {\n      transform: translateY(-7px);\n      ", "\n    }\n  }\n"])), theme_1.theme.elevation.ELEVATION_50, theme_1.theme.utils.canHover, theme_1.theme.elevation.ELEVATION_70);
var templateObject_1;
